import { useState } from "react";
import { isApiError, useCreateOrganization } from "../api";
import type { OrganizationType } from "../types";

interface OrganizationFormDialogProps {
  open: boolean;
  onClose: () => void;
}

const ORG_TYPES: { value: OrganizationType; label: string }[] = [
  { value: "holding", label: "هلدینگ" },
  { value: "company", label: "شرکت" },
  { value: "manufacturer", label: "تولیدکننده" },
  { value: "supplier", label: "تأمین‌کننده" },
  { value: "customer", label: "مشتری" },
  { value: "warehouse", label: "انبار" },
  { value: "distribution_center", label: "مرکز توزیع" },
  { value: "retail_store", label: "فروشگاه" },
  { value: "service_center", label: "مرکز خدمات" },
  { value: "department", label: "دپارتمان" },
  { value: "branch", label: "شعبه" },
];

export function OrganizationFormDialog({ open, onClose }: OrganizationFormDialogProps) {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [organizationType, setOrganizationType] = useState<OrganizationType>("department");
  const { mutate, isPending, error } = useCreateOrganization();

  if (!open) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutate(
      { code, name, organization_type: organizationType },
      {
        onSuccess: () => {
          setCode("");
          setName("");
          onClose();
        },
      },
    );
  };

  const errorMessage = isApiError(error) ? String(error.response.data.detail ?? "") : undefined;

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-lg p-6 w-full max-w-md space-y-4"
        aria-label="فرم ایجاد سازمان جدید"
      >
        <h2 className="text-lg font-semibold">سازمان جدید</h2>

        <label className="block text-sm">
          کد یکتا
          <input
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            className="mt-1 w-full border rounded px-2 py-1"
          />
        </label>

        <label className="block text-sm">
          نام
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="mt-1 w-full border rounded px-2 py-1"
          />
        </label>

        <label className="block text-sm">
          نوع سازمان
          <select
            value={organizationType}
            onChange={(e) => setOrganizationType(e.target.value as OrganizationType)}
            className="mt-1 w-full border rounded px-2 py-1"
          >
            {ORG_TYPES.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </label>

        {error && (
          <p className="text-sm text-red-500">
            {errorMessage || "خطا در ایجاد سازمان — دسترسی «tenant.manage» لازم است."}
          </p>
        )}

        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} className="px-3 py-1 rounded border">
            انصراف
          </button>
          <button
            type="submit"
            disabled={isPending}
            className="px-3 py-1 rounded bg-blue-600 text-white disabled:opacity-50"
          >
            {isPending ? "در حال ثبت..." : "ثبت سازمان"}
          </button>
        </div>
      </form>
    </div>
  );
}
